module.exports = __webpack_public_path__ + "static/media/empty_img.70f5ab2d.svg";